import React, { useState, createContext, useContext, useEffect } from "react";
import tasksAPI from "../Api/tasksAPI";
import timelogAPI from "../Api/timelogAPI";
import workflowsAPI from "../Api/workflowsAPI";
import { useUser } from "./user";

const ProjectContext = createContext();

export const ProjectProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [folder, setFolder] = useState();
  const [tasks, setTasks] = useState();
  const [timelogs, setTimelogs] = useState([]);
  const [workflows, setWorkflows] = useState([]);
  const {token} = useUser();

  useEffect(() => {
    if (folder && token) {
      setIsLoading(true);
      window.localStorage.setItem("folder", JSON.stringify(folder))
      Promise.all([
        tasksAPI.getTasksFolder(token, folder.id),
        timelogAPI.getTimeLogsFolderMonth(token, folder.id),
        workflowsAPI.getWorkflows(token),
      ]).then((res) => {
        if (res[0].data && Array.isArray(res[0].data)) {
          setTasks(
            res[0].data.sort((a, b) => {
              let d1 = new Date(Date.parse(a.date) * 1000);
              let d2 = new Date(Date.parse(b.date) * 1000);
              return d1 > d2 ? -1 : a.status > b.status ? 1 : -1;
            })
          );
        }
        if (res[1].data && Array.isArray(res[1].data)) {
          setTimelogs(res[1].data.reverse());
        }
        if (res[2].data && Array.isArray(res[2].data)) {
          setWorkflows(res[2].data);
        }
        setIsLoading(false);
      });
    }
    else {
      if(window.localStorage.getItem("folder")) setFolder(JSON.parse(window.localStorage.getItem("folder")))
    }
  }, [folder]);

  const getTime = () => {
    let time = 0;
    timelogs.forEach((t) => (time = time + t.hours));
    return time.toFixed(2);
  };

  const getTimeTask = (task) => {
    let times = timelogs.filter((t) => t.taskId === task.id);
    let time = 0;
    times.forEach((t) => (time = time + t.hours));
    return time.toFixed(2);
  };

  const getTaskNumberCompleted = () => {
    let count = 0;
    tasks.forEach((t) => {
      if (t.status === "Completed") count++;
    });
    return count;
  };

  const getTaskNumberActive = () => {
    let count = 0;
    tasks.forEach((t) => {
      if (t.status === "Active") count++;
    });
    return count;
  };

  const getTaskNumberByWorkflow = () => {
    let res = {};
    let defaultWorkflow = workflows.find(w => w.standard);
    defaultWorkflow && defaultWorkflow.customStatuses.forEach(workflow => {
      let count = 0;
      tasks.forEach((t) => {
        if (t.customStatusId === workflow.id && t.status === "Active") count++;
      });
      if(count > 0) res[workflow.name] = {count, workflow};
    })
    return res;
  }

  const getWorkflowTask = (task) => {
    let workflow;
    workflows.forEach(w => {
      let test = w.customStatuses.find(ww => ww.id === task.customStatusId);
      if (test) workflow = test;
    });
    return workflow;
  };

  return (
    <ProjectContext.Provider
      value={{
        isLoading,
        tasks,
        folder, 
        setFolder,
        timelogs,
        workflows,
        setWorkflows,
        getTime,
        getTimeTask,
        getTaskNumberCompleted,
        getTaskNumberActive,
        getWorkflowTask,
        getTaskNumberByWorkflow
      }}
    >
      {children}
    </ProjectContext.Provider>
  );
};

export const useProjet = () => useContext(ProjectContext);
